<template>
    <div>
        <p class="stack-m">Schedule payment retries using the following schedule:</p>
        <table class="table table-definition stack-m">
            <colgroup>
                <col style="width:100px;">
                <col>
            </colgroup>
            <tbody>
            <tr v-for="(attempt, index) in action.attempts">
                <td>Attempt #{{index+1}}</td>
                <td>
                    {{attempt.summary}}
                </td>
            </tr>
            </tbody>
        </table>
        <p>After each attempt {{eachAttemptSummary}}. If the last attempt fails {{lastAttemptSummary}}.</p>
    </div>
</template>

<script>
    import SchedulePaymentRetryActionModel from '@/common/models/rules/actions/schedule-payment-retry-action-model';
    import BaseActionSummary from '../base-action-summary';

    export default {
        name: 'schedule-payment-retry-summary',
        extends: BaseActionSummary,
        computed: {
            eachAttemptSummary() {
                if (this.action.afterAttemptPolicy
                    === SchedulePaymentRetryActionModel.AfterAttemptPolicies.none) {
                    return 'do nothing';
                }
                return 'change the renewal time';
            },
            lastAttemptSummary() {
                if (this.action.afterRetryEndPolicy
                    === SchedulePaymentRetryActionModel.AfterRetryEndPolicies.none) {
                    return 'do nothing';
                }
                return 'cancel the subscription';
            },
        },
    };
</script>

<style scoped>

</style>
